export default "__VITE_ASSET__mmMUlO3e__"